import React, { useEffect, useState } from 'react';
import './Skype.css';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import Topbar from './Topbar';
import VOICECALL from '../images/VOICECALL.avif'
import VIDEOCALLICON from '../images/VIDEOCALLICON.png'
import TEXTMSGICON from '../images/TEXTMSGICON.png'
import SKYPEICONS from '../images/SKYPEICONS.png'

export default function Skype() {

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  // State to manage open/close state of each FAQ item
  const [openFaq, setOpenFaq] = useState(null);

  // Toggle FAQ item
  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index); // Close if already open, otherwise open
  };

  return (
    <>
      
      <div><Navbar /></div>

      <div id="skype-page">
        {/* Header Section */}
        <section id="header-section">
          <div className="container text-center">
            <h1 className="animated-title">Connect with Us via Skype</h1>
            <p>For any inquiries or to book a session, you can easily reach out to us through Skype!</p>
          </div>
        </section>

        {/* Skype Options Section */}
        <section id="skype-options-section">
          <div className="container">
            <h2>Choose Your Preferred Way to Connect with Us</h2>
            <p>Whether you prefer a voice call, video call, or text chat, we’re ready to assist you. Select your preferred method to connect with us on Skype.</p>
           <center>
            <img src={SKYPEICONS} alt='whatsapp icons' title='whatsapp icons' id='whats'/>
                    <h5>Connect With Skype</h5>
                    </center>
            <div className="skype-options">
              <div className="skype-option">
                <a href="https://join.skype.com/invite/urtITmugbnwa" target="_blank">
                  <div className="icon">
                    <img src={VOICECALL} alt="Voice Call Icon" />
                  </div>
                  <h3>Voice Call</h3>
                  <p>Start a voice call directly with our expert for a quick consultation or inquiry.</p>
                </a>
              </div>

              <div className="skype-option">
                <a href="https://join.skype.com/invite/urtITmugbnwa" target="_blank">
                  <div className="icon">
                    <img src={VIDEOCALLICON} alt="Video Call Icon" />
                  </div>
                  <h3>Video Call</h3>
                  <p>Enjoy face-to-face interaction with our specialist for a more personal experience via video call.</p>
                </a>
              </div>

              <div className="skype-option">
                <a href="https://join.skype.com/invite/urtITmugbnwa" target="_blank">
                  <div className="icon">
                    <img src={TEXTMSGICON} alt="Text Message Icon" />
                  </div>
                  <h3>Text Message</h3>
                  <p>Send us a text message with your questions, and we’ll reply promptly with helpful answers.</p>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Extra Content Section */}
        <section id="extra-content-section">
          <div className="container text-center">
          <h2 style={{ color: "white" }}>Why Choose Us for Skype Consultations?</h2>

            <ul className="features-list">
              <li>Instant communication through Skype’s reliable platform.</li>
              <li>Prompt replies to all your inquiries via text, voice, or video.</li>
              <li>Convenient consultations that fit your schedule and needs.</li>
              <li>Personalized astrology sessions through voice or video calls for a deeper connection.</li>
            </ul>
          </div>
        </section>
        {/* <section id="contact-info">
  <h2>Contact Us</h2>
  <div class="contact-container">
    <div class="contact-item">
      <i class="fas fa-map-marker-alt"></i>
      <h3>Office Address</h3>
      <p>LIG- B, Plot No: 204, Dr. AS Rao Nagar Rd, beside SUB POST OFFICE, Anupuram Colony, A. S. Rao Nagar, Hyderabad, Secunderabad, Telangana 500062</p>
    </div>
    <div class="contact-item">
      <i class="fas fa-phone-alt"></i>
      <h3>Contact</h3>
      <p>Phone: +91 74021 67580<br/>Email:shivanadiastrologer@gmail.com</p>
    </div>
    <div class="contact-item">
      <i class="fas fa-map"></i>
      <h3>Map</h3>
      <p>
      <a href="https://www.google.com/maps?q=LIG-+B,+Plot+No:+204,+Dr.+AS+Rao+Nagar+Rd,+beside+SUB+POST+OFFICE,+Anupuram+Colony,+A.+S.+Rao+Nagar,+Hyderabad,+Secunderabad,+Telangana+500062" target="_blank">View on Google Maps</a>

      </p>
    </div>
  </div>
</section> */}
      </div>

      {/* <div><Footer /></div> */}
    </>
  );
}
